const body = document.body;
const toast = document.querySelector(".legacy-toast");
let toastTimer;

const showToast = (message, duration = 2600) => {
    if (!toast) return;

    toast.textContent = message;
    toast.hidden = false;
    toast.classList.add("is-visible");
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => {
        toast.classList.remove("is-visible");
        toast.hidden = true;
    }, duration);
};

// A server-side notice carried back on a redirect, e.g. why a game could not be launched
// (GameLaunchController redirects back with a "game" error). Without this the page just
// reloaded and the member never learned why nothing opened.
if (toast?.dataset.flash) {
    showToast(toast.dataset.flash, 6000);
}

const rememberRequestedDevice = () => {
    const requestedDevice = body?.dataset.requestedDevice;
    if (!["desktop", "mobile"].includes(requestedDevice)) return;

    document.cookie = `sx88_device=${requestedDevice}; Path=/; Max-Age=2592000; SameSite=Lax`;
};

const desktopModal = document.querySelector("[data-legacy-login-modal]");
const mobileModal = document.querySelector("#r-side-bar");
const modal = desktopModal || mobileModal;
const overlay = document.createElement("div");
overlay.className = "md-overlay legacy-login-overlay";
overlay.hidden = true;
document.body.append(overlay);
let modalTrigger = null;

const loginFocusableElements = () => {
    if (!modal) return [];

    return [
        ...modal.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
        ),
    ].filter(
        (element) => !element.hidden && element.getClientRects().length > 0,
    );
};

const openLogin = (trigger) => {
    if (!modal) return;

    modalTrigger = trigger || document.activeElement;
    modal.removeAttribute("inert");
    modal.classList.add("md-show", "is-open", "open");
    if (mobileModal) {
        mainContent?.classList.add("rightSideBarOpen");
        window.setTimeout(
            () => mobileModal.dispatchEvent(new Event("legacy:sidebar-open")),
            330,
        );
    }
    modal.setAttribute("aria-hidden", "false");
    overlay.hidden = false;
    overlay.classList.add("is-visible");
    body.classList.add("legacy-modal-open");
    window.setTimeout(() => {
        const isMemberSidebar = modal.matches("[data-member-sidebar]");
        const focusTarget = isMemberSidebar
            ? modal.querySelector('[data-legacy-login-close], #btn-close--login-modal')
            : (modal.querySelector('input:not([type="hidden"])') ??
              modal.querySelector('[data-legacy-login-close], #btn-close--login-modal, a[href]'));

        if (isMemberSidebar) {
            const sidebarContent = modal.querySelector(".side-bar-content");
            sidebarContent?.scrollTo({ top: 0, left: 0 });
        }

        focusTarget?.focus({ preventScroll: true });
    }, 30);
};

const closeLogin = () => {
    if (!modal) return;

    modal.classList.remove("md-show", "is-open", "open");
    modal.setAttribute("inert", "");
    if (mobileModal) mainContent?.classList.remove("rightSideBarOpen");
    modal.setAttribute("aria-hidden", "true");
    overlay.classList.remove("is-visible");
    overlay.hidden = true;
    body.classList.remove("legacy-modal-open");
    modalTrigger?.focus?.();
};

document
    .querySelectorAll(
        "[data-legacy-login-open], [data-legacy-account-open], #btnToggleRSideNav, #btnLogin--home",
    )
    .forEach((trigger) => {
        trigger.addEventListener("click", (event) => {
            event.preventDefault();
            openLogin(trigger);
        });
    });

document
    .querySelectorAll("[data-legacy-login-close], #btn-close--login-modal")
    .forEach((trigger) => {
        trigger.addEventListener("click", closeLogin);
    });
overlay.addEventListener("click", closeLogin);

// A rejected login has to come back visible. Everywhere but /login that means reopening the
// modal, which is the only login UI those pages have. /login renders #auth-page-card, an
// always-visible copy of the same form that already shows the error, so reopening the modal
// there stacks a second login form on top of the first — both filled, both complaining.
if (document.querySelector("[data-login-error]")) {
    const pageCard = document.querySelector("#auth-page-card");

    window.setTimeout(() => {
        if (!pageCard) {
            openLogin(
                document.querySelector(
                    "[data-legacy-login-open], #btnToggleRSideNav, #btnLogin--home",
                ),
            );
        }
        (pageCard?.querySelector("[data-login-error]") ??
            document.querySelector("[data-login-error]"))?.scrollIntoView({
            block: "center",
        });
    }, 0);
}

document.querySelectorAll("[data-demo-form]").forEach((form) => {
    form.addEventListener("submit", (event) => {
        event.preventDefault();
        const password = form.querySelector(
            '[name="pass"], [name="password"], [name="new_password"]',
        );
        const passwordConfirmation = form.querySelector(
            '[name="password_confirm"], [name="password_confirmation"], [name="new_password_confirmation"]',
        );
        if (password && passwordConfirmation) {
            passwordConfirmation.setCustomValidity(
                password.value === passwordConfirmation.value
                    ? ""
                    : "Konfirmasi kata sandi tidak sama.",
            );
        }
        const captchaInput = form.querySelector("[data-captcha-input]");
        const captchaCode = form
            .querySelector("[data-captcha-code]")
            ?.textContent?.trim();
        if (captchaInput && captchaCode) {
            captchaInput.setCustomValidity(
                captchaInput.value.trim() === captchaCode
                    ? ""
                    : "Kode captcha tidak sesuai.",
            );
        }
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }
        showToast(
            form.dataset.demoMessage ||
                "Mode pratinjau frontend — data tidak dikirim.",
        );
        if (form.dataset.demoRedirect) {
            window.setTimeout(
                () => window.location.assign(form.dataset.demoRedirect),
                250,
            );
        }
    });
});

document
    .querySelectorAll(
        '[name="password_confirm"], [name="password_confirmation"], [name="new_password_confirmation"]',
    )
    .forEach((input) => {
        input.addEventListener("input", () => input.setCustomValidity(""));
    });

document.querySelectorAll("[data-captcha-input]").forEach((input) => {
    input.addEventListener("input", () => input.setCustomValidity(""));
});

document.querySelectorAll("[data-captcha-refresh]").forEach((trigger) => {
    trigger.addEventListener("click", () => {
        const form = trigger.closest("form");
        const code = form?.querySelector("[data-captcha-code]");
        const input = form?.querySelector("[data-captcha-input]");
        if (!code) return;
        code.textContent = String(Math.floor(1000 + Math.random() * 9000));
        if (input) {
            input.value = "";
            input.setCustomValidity("");
            input.focus();
        }
    });
});

document.querySelectorAll(".toggle-password").forEach((trigger) => {
    trigger.setAttribute("role", "button");
    trigger.setAttribute("tabindex", "0");
    const toggle = () => {
        const selector = trigger.getAttribute("input_id");
        const input = selector ? document.querySelector(selector) : null;
        if (!input) return;
        input.type = input.type === "password" ? "text" : "password";
        trigger.classList.toggle("icon-eye", input.type === "password");
        trigger.classList.toggle("icon-eye-blocked", input.type !== "password");
    };
    trigger.addEventListener("click", toggle);
    trigger.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            toggle();
        }
    });
});

document.querySelectorAll(".pinkey").forEach((trigger) => {
    trigger.addEventListener("click", () => {
        const form = trigger.closest("form");
        const inputs = [...(form?.querySelectorAll(".pincode") || [])];
        const nextInput = inputs.find((input) => input.value === "");
        const value = (trigger.value || trigger.textContent || "").trim();
        if (!nextInput || !/^\d$/.test(value)) return;
        nextInput.value = value;
        nextInput.dispatchEvent(new Event("input", { bubbles: true }));
        inputs.find((input) => input.value === "")?.focus();
    });
});

document
    .querySelectorAll('#back_bt, .legacy-pin-form [type="reset"]')
    .forEach((trigger) => {
        trigger.addEventListener("click", () => {
            const inputs = [
                ...(trigger.closest("form")?.querySelectorAll(".pincode") ||
                    []),
            ];
            inputs.forEach((input) => {
                input.value = "";
            });
            inputs[0]?.focus();
        });
    });

const loginForm = document.querySelector("#loginForm");
const resetForm = document.querySelector("#resetPwdForm");
document
    .querySelector("#forgotPwd-btn--login-modal")
    ?.addEventListener("click", () => {
        if (loginForm) loginForm.style.display = "none";
        if (resetForm) resetForm.style.display = "";
    });
document
    .querySelector(
        "#backToLogin, #btn-back--reset-password, #btn-back--login-modal, [data-back-to-login]",
    )
    ?.addEventListener("click", () => {
        if (resetForm) resetForm.style.display = "none";
        if (loginForm) loginForm.style.display = "";
    });

const sideNav = document.querySelector("#sideNav");
const mainContent = document.querySelector("#mainContent");
const toggleSideNav = (force) => {
    if (!sideNav) return;
    const shouldOpen = force ?? !sideNav.classList.contains("is-open");
    sideNav.classList.toggle("is-open", shouldOpen);
    sideNav.classList.toggle("open", shouldOpen);
    mainContent?.classList.toggle("side-nav-open", shouldOpen);
    mainContent?.classList.toggle("sideNavOpen", shouldOpen);
    body.classList.toggle("legacy-side-nav-open", shouldOpen);

    if (!shouldOpen) {
        sideNav.classList.remove("navContentOpen");
        mainContent?.classList.remove("navContentOpen");
        sideNav.querySelectorAll(".navlink.has-sub").forEach((trigger) => {
            trigger.classList.remove("is-expanded", "active");
            trigger.setAttribute("aria-expanded", "false");
            trigger.nextElementSibling?.classList.remove("is-open", "open");
        });
        if (document.scrollingElement) document.scrollingElement.scrollLeft = 0;
    }

    document
        .querySelector("#btnToggleSideNav")
        ?.setAttribute("aria-expanded", String(shouldOpen));
};
document
    .querySelector("#btnToggleSideNav")
    ?.addEventListener("click", () => toggleSideNav());
document
    .querySelector("#mainContentContainer")
    ?.addEventListener("click", (event) => {
        if (
            body.classList.contains("legacy-side-nav-open") &&
            event.target === event.currentTarget
        )
            toggleSideNav(false);
    });
const sideNavSubmenuTriggers = [
    ...document.querySelectorAll("#sideNav .navlink.has-sub"),
];
sideNavSubmenuTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
        event.preventDefault();

        const submenu = trigger.nextElementSibling;
        if (!submenu) return;

        const shouldOpen = !submenu.classList.contains("is-open");
        if (shouldOpen) {
            sideNavSubmenuTriggers.forEach((otherTrigger) => {
                if (otherTrigger === trigger) return;
                otherTrigger.classList.remove("is-expanded", "active");
                otherTrigger.setAttribute("aria-expanded", "false");
                otherTrigger.nextElementSibling?.classList.remove(
                    "is-open",
                    "open",
                );
            });
        }

        trigger.classList.toggle("is-expanded", shouldOpen);
        trigger.classList.toggle("active", shouldOpen);
        trigger.setAttribute("aria-expanded", String(shouldOpen));
        submenu.classList.toggle("is-open", shouldOpen);
        submenu.classList.toggle("open", shouldOpen);
        const hasOpenSubmenu = sideNavSubmenuTriggers.some((item) =>
            item.nextElementSibling?.classList.contains("is-open"),
        );
        sideNav?.classList.toggle("navContentOpen", hasOpenSubmenu);
        mainContent?.classList.toggle("navContentOpen", hasOpenSubmenu);
    });
});
document.querySelectorAll("[data-side-nav-close]").forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
        event.preventDefault();
        toggleSideNav(false);
    });
});

document.querySelector("#btn-close--apk")?.addEventListener("click", () => {
    document.querySelector("#apk-down-bar")?.remove();
});

document.querySelector("#close-promo-sticky")?.addEventListener("click", () => {
    document.querySelector(".promo-sticky")?.remove();
});

document
    .querySelector("#serverDropdown")
    ?.addEventListener("change", (event) => {
        const status = document.querySelector(
            ".server-selector-ui .event-status span",
        );
        const selectedLabel =
            event.currentTarget.selectedOptions?.[0]?.textContent?.trim();
        if (status && selectedLabel)
            status.textContent = `Terhubung ke ${selectedLabel}`;
    });

const carousel = document.querySelector("#carousel-fixed-height");
if (carousel) {
    const slides = [...carousel.querySelectorAll(".carousel-inner > .item")];
    const indicators = [
        ...carousel.querySelectorAll(".carousel-indicators > li"),
    ];
    let activeIndex = Math.max(
        0,
        slides.findIndex((slide) => slide.classList.contains("active")),
    );
    let carouselTimer;
    const carouselToggle = carousel.querySelector("[data-carousel-toggle]");
    const requestedCarouselInterval = Number.parseInt(
        carousel.dataset.interval || "2000",
        10,
    );
    const carouselInterval =
        Number.isFinite(requestedCarouselInterval) && requestedCarouselInterval > 0
            ? requestedCarouselInterval
            : 2000;
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    let userPaused = reducedMotion.matches;
    let interactionPaused = false;

    const showSlide = (index) => {
        if (!slides.length) return;
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) =>
            slide.classList.toggle("active", slideIndex === activeIndex),
        );
        indicators.forEach((indicator, indicatorIndex) =>
            indicator.classList.toggle(
                "active",
                indicatorIndex === activeIndex,
            ),
        );
    };
    const stopCarousel = () => {
        window.clearInterval(carouselTimer);
        carouselTimer = undefined;
    };
    const updateCarouselToggle = () => {
        if (!carouselToggle) return;
        carouselToggle.setAttribute("aria-pressed", String(userPaused));
        carouselToggle.setAttribute(
            "aria-label",
            userPaused ? "Lanjutkan carousel" : "Jeda carousel",
        );
        carouselToggle.textContent = userPaused ? "Lanjutkan" : "Jeda";
    };
    const restartCarousel = () => {
        stopCarousel();
        if (userPaused || interactionPaused || reducedMotion.matches) return;
        carouselTimer = window.setInterval(
            () => showSlide(activeIndex + 1),
            carouselInterval,
        );
    };
    carouselToggle?.addEventListener("click", () => {
        userPaused = !userPaused;
        updateCarouselToggle();
        restartCarousel();
    });
    carousel.addEventListener("focusin", () => {
        interactionPaused = true;
        stopCarousel();
    });
    carousel.addEventListener("focusout", (event) => {
        if (carousel.contains(event.relatedTarget)) return;
        interactionPaused = false;
        restartCarousel();
    });
    carousel.addEventListener("mouseenter", () => {
        interactionPaused = true;
        stopCarousel();
    });
    carousel.addEventListener("mouseleave", () => {
        interactionPaused = false;
        restartCarousel();
    });
    carousel
        .querySelector('[data-slide="prev"]')
        ?.addEventListener("click", (event) => {
            event.preventDefault();
            showSlide(activeIndex - 1);
            restartCarousel();
        });
    carousel
        .querySelector('[data-slide="next"]')
        ?.addEventListener("click", (event) => {
            event.preventDefault();
            showSlide(activeIndex + 1);
            restartCarousel();
        });
    indicators.forEach((indicator, index) =>
        indicator.addEventListener("click", () => {
            showSlide(index);
            restartCarousel();
        }),
    );
    updateCarouselToggle();
    restartCarousel();
}

// The provider strip's prev/next arrows scroll `.slider-content` sideways by one step. The
// reference wires this with jQuery's `animate({scrollLeft: "+=300px"})`; this reproduces the
// same ±300px step with the native smooth-scroll API. Both device variants share the same
// shape — a `.left`/`.right` button flanking `.slider-content` — the mobile one just nests it
// inside an extra `.scroller` wrapper, so `.closest(".slider, .scroll-wrapper")` finds either.
document
    .querySelectorAll("#left-button, #right-button, #left-button-mobile, #right-button-mobile")
    .forEach((button) => {
        const track = button
            .closest(".slider, .scroll-wrapper")
            ?.querySelector(".slider-content");
        if (!track) return;

        const direction = button.id.startsWith("left-button") ? -1 : 1;
        button.addEventListener("click", (event) => {
            event.preventDefault();
            track.scrollBy({ left: direction * 300, behavior: "smooth" });
        });
    });

// Desktop top-bar share button: slides the social icons open (the theme animates
// `.social-icons.fade-in.show`) and swaps the share/close glyphs. Nothing handled it before,
// so the button did nothing.
{
    const shareButton = document.querySelector("#btn-showSocialIcons--top-bar");
    const shareIcons = document.querySelector("#blk-socialIcons--top-bar");
    shareButton?.addEventListener("click", () => {
        if (!shareIcons) return;
        const open = shareIcons.classList.toggle("show");
        shareButton.setAttribute("aria-expanded", String(open));
        shareButton.querySelector(".icon-share")?.classList.toggle("hide", open);
        shareButton.querySelector(".icon-close")?.classList.toggle("hide", !open);
    });
}

const socialMenu = document.querySelector(".ard-sosmed");
const socialMenuTrigger = socialMenu?.querySelector(".hamburg");
const setSocialMenuOpen = (force) => {
    if (!socialMenu || !socialMenuTrigger) return;
    const shouldOpen = force ?? !socialMenu.classList.contains("open");
    socialMenu.classList.toggle("open", shouldOpen);
    socialMenuTrigger.setAttribute("aria-expanded", String(shouldOpen));
};
socialMenuTrigger?.addEventListener("click", () => setSocialMenuOpen());

const toggleMenuTriggers = [
    ...document.querySelectorAll(".togglemenu-trigger"),
];
const toggleMenuTarget = (trigger) => {
    const selector = trigger.dataset.showid || "";
    return selector.startsWith("#")
        ? document.getElementById(selector.slice(1))
        : null;
};
const closeToggleMenus = (except = null) => {
    toggleMenuTriggers.forEach((trigger) => {
        const target = toggleMenuTarget(trigger);
        if (target === except) return;
        target?.classList.remove("is-open", "show");
        trigger.setAttribute("aria-expanded", "false");
    });
};

toggleMenuTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
        event.preventDefault();
        const target = toggleMenuTarget(trigger);
        if (!target) return;

        const shouldOpen = !target.classList.contains("is-open");
        closeToggleMenus(target);
        target.classList.toggle("is-open", shouldOpen);
        target.classList.toggle("show", shouldOpen);
        trigger.setAttribute("aria-expanded", String(shouldOpen));
    });
});
document.addEventListener("click", (event) => {
    if (event.target.closest(".togglemenu-trigger, .togglemenu-content")) return;
    closeToggleMenus();
});

// Footer "More Info" dropdown with the admin-managed SEO article. Desktop hides the body
// with the reference's `.hide` class and swaps the More/Less labels; mobile opens it with
// `.is-open`. The old handler only looked for the mobile footer, so desktop never opened.
document.querySelectorAll("#collapsible-footer").forEach((trigger) => {
    let body = trigger.nextElementSibling;
    while (body && !body.classList.contains("footer-body")) {
        body = body.nextElementSibling;
    }
    if (!body) return;

    const usesHide = body.classList.contains("hide");
    const moreLabel = trigger.querySelector("#more-txt");
    const lessLabel = trigger.querySelector("#less-txt");

    trigger.setAttribute("role", "button");
    trigger.setAttribute("tabindex", "0");
    trigger.setAttribute("aria-expanded", "false");
    if (body.id) trigger.setAttribute("aria-controls", body.id);
    trigger.style.cursor = "pointer";

    const toggle = () => {
        const open = usesHide
            ? !body.classList.toggle("hide")
            : body.classList.toggle("is-open");
        moreLabel?.classList.toggle("hide", open);
        lessLabel?.classList.toggle("hide", !open);
        trigger.setAttribute("aria-expanded", String(open));
    };

    trigger.addEventListener("click", toggle);
    trigger.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            toggle();
        }
    });
});

document
    .querySelector("#btn-wrap--goToTop")
    ?.addEventListener("click", () =>
        window.scrollTo({ top: 0, behavior: "smooth" }),
    );

document.querySelectorAll("[data-legacy-demo-action]").forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
        event.preventDefault();

        if (window.LiveChatWidget) {
            window.LiveChatWidget.call("maximize");
        } else if (window.Tawk_API?.maximize) {
            window.Tawk_API.maximize();
        } else if (window.$crisp) {
            window.$crisp.push(["do", "chat:open"]);
        } else if (trigger.dataset.liveChatUrl) {
            window.open(trigger.dataset.liveChatUrl, "_blank", "noopener");
        } else {
            showToast("Live chat sedang memuat, silakan coba lagi.");
        }
    });
});

document.querySelectorAll("[data-support-channel]").forEach((trigger) => {
    trigger.addEventListener("click", () => {
        showToast(
            `${trigger.textContent.trim().split(/\s{2,}/)[0]} tersedia sebagai pratinjau frontend.`,
        );
    });
});

const faqList = document.querySelector("[data-faq-list]");
if (faqList) {
    const search = document.querySelector("[data-faq-search]");
    const items = [...faqList.querySelectorAll("[data-faq-item]")];
    const empty = document.querySelector("[data-faq-empty]");
    let category =
        document.querySelector("[data-faq-category].active")?.dataset
            .faqCategory || "all";

    const filterFaq = () => {
        const needle = search?.value.trim().toLowerCase() || "";
        let visible = 0;
        items.forEach((item) => {
            const categoryMatches =
                category === "all" ||
                item.dataset.faqCategoryValue === category;
            const searchMatches =
                needle === "" ||
                (
                    item.dataset.faqText || item.textContent.toLowerCase()
                ).includes(needle);
            item.hidden = !(categoryMatches && searchMatches);
            if (!item.hidden) visible += 1;
        });
        if (empty) empty.hidden = visible > 0;
    };

    search?.addEventListener("input", filterFaq);
    document.querySelectorAll("[data-faq-category]").forEach((trigger) => {
        trigger.addEventListener("click", (event) => {
            const targetCategory = trigger.dataset.faqCategory || "all";
            const hasTargetItems =
                targetCategory === "all" ||
                items.some(
                    (item) => item.dataset.faqCategoryValue === targetCategory,
                );
            if (!hasTargetItems) return;
            event.preventDefault();
            category = targetCategory;
            document
                .querySelectorAll("[data-faq-category]")
                .forEach((item) =>
                    item.classList.toggle("active", item === trigger),
                );
            filterFaq();
        });
    });
    filterFaq();
}

const chatPreview = document.querySelector("[data-legacy-chat-preview]");
const chatLauncher = document.querySelector("[data-legacy-chat-open]");
const setChatOpen = (open) => {
    if (!chatPreview || !chatLauncher) return;
    chatPreview.hidden = !open;
    chatLauncher.setAttribute("aria-expanded", String(open));
};
chatLauncher?.addEventListener("click", () => setChatOpen(true));
document.querySelectorAll("[data-legacy-chat-close]").forEach((trigger) => {
    trigger.addEventListener("click", () => setChatOpen(false));
});

const jackpot = document.querySelector("#jackpot_amount");
if (jackpot) {
    const match = jackpot.textContent.match(/[\d,.]+/);
    const numericToken = match?.[0] || "35887830267";
    // Accept both the reference's en-US format (35,887,830,267.00) and the
    // Indonesian grouping format used by the shared fixture (8.888.888.888).
    const normalizedToken = numericToken.split(".").length > 2
        ? numericToken.replace(/[.,]/g, "")
        : numericToken.replace(/,/g, "");
    let value = Number(normalizedToken);
    if (!Number.isFinite(value)) value = 35887830267;
    window.setInterval(() => {
        value += Math.random() * 1700 + 250;
        jackpot.textContent = `IDR ${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }, 1800);
}

document.querySelectorAll("[data-public-rtp-filter]").forEach((form) => {
    const query = form.querySelector("[data-public-rtp-query]");
    const provider = form.querySelector("[data-public-rtp-provider]");
    const items = [...document.querySelectorAll("[data-public-rtp-item]")];
    const count = document.querySelector("[data-public-rtp-count]");
    const empty = document.querySelector("[data-public-rtp-empty]");
    const filter = () => {
        const searchValue = query?.value.trim().toLowerCase() || "";
        const providerValue = provider?.value.trim().toLowerCase() || "";
        let visible = 0;

        items.forEach((item) => {
            const matchesSearch =
                !searchValue || item.dataset.name?.includes(searchValue);
            const matchesProvider =
                !providerValue || item.dataset.provider === providerValue;
            item.hidden = !(matchesSearch && matchesProvider);
            if (!item.hidden) visible += 1;
        });

        if (count) count.textContent = `${visible} item fixture`;
        if (empty) empty.hidden = visible > 0;
    };
    query?.addEventListener("input", filter);
    provider?.addEventListener("change", filter);
    form.addEventListener("submit", filter);
    filter();
});

document.addEventListener("keydown", (event) => {
    if (event.key === "Tab" && body.classList.contains("legacy-modal-open")) {
        const focusable = loginFocusableElements();
        const first = focusable[0];
        const last = focusable.at(-1);

        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first?.focus();
        }
    }

    if (event.key !== "Escape") return;
    if (body.classList.contains("legacy-modal-open")) closeLogin();
    if (body.classList.contains("legacy-side-nav-open")) toggleSideNav(false);
    setSocialMenuOpen(false);
    closeToggleMenus();
});

// The reference registers in two stages tracked by #stage_val: account details, then bank
// details. Both stages post together here, so this only reveals one block at a time — with JS
// off nothing is hidden and the whole form still submits.
document.querySelectorAll("[data-legacy-register-stage]").forEach((controls) => {
    const form = controls.closest("form");
    if (!form) return;

    const stageOne = form.querySelector(".register_form_one");
    const stageTwo = form.querySelector(".register_form_two");
    const stageVal = form.querySelector("#stage_val");
    const nextBtn = controls.querySelector("#register_form_two_next_btn");
    const prevBtn = controls.querySelector("#register_form_two_prev_btn");
    const submitBtn = controls.querySelector("#register_form_two_submit_btn");
    const title = document.querySelector("#step_title");
    if (!stageOne || !stageTwo || !nextBtn || !prevBtn || !submitBtn) return;

    const showStage = (stage) => {
        stageOne.hidden = stage !== 0;
        stageTwo.hidden = stage !== 1;
        nextBtn.hidden = stage !== 0;
        prevBtn.hidden = stage !== 1;
        submitBtn.hidden = stage !== 1;
        if (stageVal) stageVal.value = String(stage);
        if (title) {
            const label = stage === 0 ? "Daftar Akun" : "Data Bank";
            title.dataset.title = label;
            title.innerHTML = `<span>${label}</span>`;
        }
    };

    nextBtn.querySelector("button")?.addEventListener("click", () => {
        // Point at the first invalid stage-one field rather than carrying it forward.
        const invalid = [...stageOne.querySelectorAll("input, select")].find(
            (field) => !field.checkValidity(),
        );
        if (invalid) {
            invalid.reportValidity();
            return;
        }
        showStage(1);
        form.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    prevBtn.querySelector("button")?.addEventListener("click", () => {
        showStage(0);
        form.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    // A rejected submit can fail on either stage; open the one that carries the errors.
    // Keyed on role="alert", which only the @error blocks emit — .text-danger is also worn
    // by the required-field asterisks, which are always present.
    showStage(stageTwo.querySelector('[role="alert"]') ? 1 : 0);
});

// The dialling-code pickers are Bootstrap 3 dropdowns in the reference markup — a
// [data-toggle="dropdown"] button, a hidden input holding the value, and a .dropdown-menu of
// .js-opt links. Bootstrap's own JS is not loaded here, so this supplies the two behaviours the
// markup implies: toggling .open on the parent (what .open>.dropdown-menu keys off), and writing
// the chosen code into both the button label and the hidden input that actually posts.
const dropdownGroups = [];

document.querySelectorAll('[data-toggle="dropdown"]').forEach((toggle) => {
    const group = toggle.parentElement;
    if (!group?.querySelector(".dropdown-menu")) return;

    dropdownGroups.push(group);
    toggle.setAttribute("aria-expanded", "false");

    const setOpen = (open) => {
        group.classList.toggle("open", open);
        const menu = group.querySelector(".dropdown-menu");
        if (menu) {
            menu.classList.toggle("show", open);
        }
        toggle.setAttribute("aria-expanded", String(open));
    };

    toggle.addEventListener("click", (event) => {
        event.preventDefault();
        const opening = !group.classList.contains("open");
        closeDropdowns();
        setOpen(opening);
    });

    const label = toggle.querySelector("span:not(.caret)");
    const field = group.querySelector('input[type="hidden"]');

    group.querySelectorAll(".js-opt").forEach((option) => {
        option.addEventListener("click", (event) => {
            event.preventDefault();
            const code = option.dataset.value ?? "";
            if (field) field.value = code;
            if (label) label.textContent = ` +${code}`;
            setOpen(false);
        });
    });
});

// Only the groups collected above are closed on an outside click. `.open` is not a private
// class — #r-side-bar, the mobile login drawer, is width:0 until it carries exactly that class —
// so a blanket querySelectorAll('.open') here would slam the drawer shut on the next click.
function closeDropdowns() {
    dropdownGroups.forEach((group) => {
        group.classList.remove("open");
        group.querySelector(".dropdown-menu")?.classList.remove("show");
        group
            .querySelector('[data-toggle="dropdown"]')
            ?.setAttribute("aria-expanded", "false");
    });
}

document.addEventListener("click", (event) => {
    if (event.target.closest('.dropdown-menu, [data-toggle="dropdown"]')) return;
    closeDropdowns();
});

document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
        closeDropdowns();
    }
});

// The bank and e-wallet selects share name="bank_name", the way the reference ships them, so
// exactly one of them may be enabled at a time or the browser would post both. Which one is
// visible is decided by the :has() rules in auth-promo-pages.css; this mirrors that choice onto
// the disabled attribute, which CSS cannot reach. Server-rendered state already matches the
// checked radio, so this only has to keep up with clicks.
{
    const bankSelect = document.querySelector('[data-legacy-account-options="bank"]');
    const ewalletSelect = document.querySelector('[data-legacy-account-options="ewallet"]');

    if (bankSelect && ewalletSelect) {
        const syncAccountOptions = () => {
            const ewalletChosen =
                document.querySelector("#radioEwallet7")?.checked ||
                document.querySelector("#method")?.value === "7";
            bankSelect.disabled = Boolean(ewalletChosen);
            ewalletSelect.disabled = !ewalletChosen;
        };

        document
            .querySelectorAll('[name="method"]')
            .forEach((control) => control.addEventListener("change", syncAccountOptions));
        syncAccountOptions();
    }
}

// The reference uses Swiper for the two cards in the authenticated mobile profile drawer.
// Keep its DOM and class names, but provide the small two-slide interaction locally so the
// drawer does not depend on the reference site's external script.
{
    const walletSlider = document.querySelector("#r-side-bar #wallet-slider");

    if (walletSlider) {
        const wrapper = walletSlider.querySelector(".swiper-wrapper");
        const slides = [...walletSlider.querySelectorAll(".swiper-slide")];
        const previous = walletSlider.querySelector(".swiper-button-prev");
        const next = walletSlider.querySelector(".swiper-button-next");
        let currentIndex = 0;

        const updateWalletSlider = (animate = true) => {
            if (!wrapper || slides.length === 0 || walletSlider.clientWidth === 0) return;

            currentIndex = Math.max(0, Math.min(currentIndex, slides.length - 1));
            const activeSlide = slides[currentIndex];
            const offset =
                walletSlider.clientWidth / 2 -
                (activeSlide.offsetLeft + activeSlide.offsetWidth / 2);

            wrapper.style.transitionDuration = `${animate ? 320 : 0}ms`;
            wrapper.style.transform = `translate3d(${Math.round(offset)}px, 0, 0)`;

            slides.forEach((slide, index) => {
                slide.classList.toggle("swiper-slide-active", index === currentIndex);
                slide.classList.toggle("swiper-slide-prev", index === currentIndex - 1);
                slide.classList.toggle("swiper-slide-next", index === currentIndex + 1);
            });

            const atStart = currentIndex === 0;
            const atEnd = currentIndex === slides.length - 1;
            previous?.classList.toggle("swiper-button-disabled", atStart);
            next?.classList.toggle("swiper-button-disabled", atEnd);
            previous?.setAttribute("aria-disabled", String(atStart));
            next?.setAttribute("aria-disabled", String(atEnd));
            if (previous) previous.tabIndex = atStart ? -1 : 0;
            if (next) next.tabIndex = atEnd ? -1 : 0;
        };

        previous?.addEventListener("click", () => {
            currentIndex -= 1;
            updateWalletSlider();
        });
        next?.addEventListener("click", () => {
            currentIndex += 1;
            updateWalletSlider();
        });
        walletSlider.addEventListener("legacy:sidebar-open", () => updateWalletSlider(false));
        window.addEventListener("resize", () => updateWalletSlider(false));
        if ("ResizeObserver" in window) {
            new ResizeObserver(() => updateWalletSlider(false)).observe(walletSlider);
        }
        updateWalletSlider(false);
    }
}

// Wallet balance, shown to a signed-in member in the desktop header (#user-balance and the
// .wallet-balance-dd list) and in the mobile .wallet-bal bar. This lived inline in the desktop
// template, so mobile members saw no balance at all; it belongs in the shared bundle because
// both device layouts render a balance. .btn-refresh-wallet is the reference's own class for the
// controls that ask for a fresh figure.
{
    const balanceAmounts = document.querySelectorAll(
        "#user-balance .balance-amount, .wallet-balance-dd .balance-amount, .wallet-bal .balance-amount, #r-side-bar #wallet-slider .balance-amount",
    );

    if (balanceAmounts.length > 0) {
        const applyBalance = (raw) => {
            const text = (Number(raw) || 0).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            balanceAmounts.forEach((el) => {
                el.textContent = text;
            });
        };

        // Stops polling once the endpoint reports the balance source is unavailable.
        // Repeating a request that cannot succeed just burns a server worker every 30
        // seconds per open tab for a figure that will not change.
        let pollTimer = null;
        const stopPolling = () => {
            if (pollTimer !== null) {
                window.clearInterval(pollTimer);
                pollTimer = null;
            }
        };

        const balanceHeaders = {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
        };

        const showBalance = (data) => {
            applyBalance(data.success ? data.balance : 0);
            if (data.available === false) stopPolling();
        };

        const refreshBalance = () =>
            fetch("/api/balance", {
                headers: balanceHeaders,
                credentials: "same-origin",
            })
                .then((response) => response.json())
                .then(showBalance)
                .catch(() => applyBalance(0));

        // A launch moves the whole balance to the game provider; loading a page means the
        // member is back, so the server pulls it home first. Only on load and on the
        // refresh button — the 30-second poll must not reach into a running game.
        const syncBalance = () =>
            fetch("/api/balance/sync", {
                method: "POST",
                headers: {
                    ...balanceHeaders,
                    "X-CSRF-TOKEN":
                        document.querySelector('meta[name="csrf-token"]')?.content ?? "",
                },
                credentials: "same-origin",
            })
                .then((response) => {
                    if (!response.ok) throw new Error(String(response.status));
                    return response.json();
                })
                .then(showBalance)
                .catch(refreshBalance);

        document
            .querySelectorAll(".btn-refresh-wallet")
            .forEach((trigger) =>
                trigger.addEventListener("click", syncBalance),
            );

        syncBalance();
        pollTimer = window.setInterval(refreshBalance, 30000);
    }
}

// The reference's demo launcher. There is no game backend here, so it says so rather than
// dropping the click silently or sending the visitor somewhere unrelated.
document.querySelectorAll("[data-demo-play]").forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
        event.preventDefault();
        showToast("Mode demo menunggu integrasi backend permainan.");
    });
});

// Desktop Mega Menu Dropdown Hover Lock
const initDesktopNavHover = () => {
    const navItems = document.querySelectorAll(".main.nav-wrapper .main-nav .nav-item");
    navItems.forEach((item) => {
        const content = item.querySelector(".nav-item-content");
        if (!content) return;

        let closeTimer = null;

        const openMenu = () => {
            if (closeTimer) {
                clearTimeout(closeTimer);
                closeTimer = null;
            }
            item.classList.add("is-hovered");
            content.classList.add("is-open");
        };

        const scheduleClose = () => {
            if (closeTimer) clearTimeout(closeTimer);
            closeTimer = setTimeout(() => {
                item.classList.remove("is-hovered");
                content.classList.remove("is-open");
                closeTimer = null;
            }, 150);
        };

        item.addEventListener("mouseenter", openMenu);
        item.addEventListener("mouseleave", scheduleClose);
        content.addEventListener("mouseenter", openMenu);
        content.addEventListener("mouseleave", scheduleClose);
    });
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDesktopNavHover);
} else {
    initDesktopNavHover();
}

// The member drawer's tab bar. The reference swaps the tab body inside #r-side-bar rather
// than navigating: its own capture shows the change-password form sitting in .outlet
// .tab-content with that tab marked active, while the page behind the drawer was a different
// section entirely. Only the two tabs native leaves visible on mobile have a pane here —
// `.mobile .profile-head .container .ref_down {display:none}` hides the other three — and every
// tab keeps a real href, so a client without JS still reaches the full page.
{
    const drawer = document.querySelector("#r-side-bar");
    const tabs = drawer
        ? [...drawer.querySelectorAll(".mdc-tab[data-sidebar-tab]")]
        : [];

    if (tabs.length > 0) {
        const panes = [...drawer.querySelectorAll("[data-sidebar-pane]")];

        const selectTab = (name) => {
            tabs.forEach((tab) => {
                const active = tab.dataset.sidebarTab === name;
                tab.classList.toggle("active", active);
                tab.setAttribute("aria-selected", active ? "true" : "false");
                tab.tabIndex = active ? 0 : -1;
                // .mdc-tab-indicator.active is what native paints the underline from;
                // it is a sibling of the label, not a class on the tab itself.
                tab.querySelector(".mdc-tab-indicator")?.classList.toggle(
                    "active",
                    active,
                );
            });

            panes.forEach((pane) => {
                pane.classList.toggle(
                    "active",
                    pane.dataset.sidebarPane === name,
                );
            });
        };

        tabs.forEach((tab) => {
            tab.addEventListener("click", (event) => {
                // Only intercept tabs that have somewhere to switch to. A tab whose pane is
                // absent must follow its href rather than silently do nothing.
                if (!panes.some((p) => p.dataset.sidebarPane === tab.dataset.sidebarTab)) {
                    return;
                }
                event.preventDefault();
                selectTab(tab.dataset.sidebarTab);
            });

            // Roving focus across the tab strip, per the tablist keyboard contract.
            tab.addEventListener("keydown", (event) => {
                const step =
                    event.key === "ArrowRight" ? 1 : event.key === "ArrowLeft" ? -1 : 0;
                if (step === 0) return;
                const visible = tabs.filter((t) => t.offsetParent !== null);
                const index = visible.indexOf(tab);
                if (index === -1) return;
                event.preventDefault();
                const next =
                    visible[(index + step + visible.length) % visible.length];
                selectTab(next.dataset.sidebarTab);
                next.focus();
            });
        });
    }
}

// The drawer's change-password form. The reference posts it without leaving the drawer and
// writes the outcome into .message--chg-pass, so this submits to the same Laravel route over
// fetch and renders what comes back. Laravel answers a rejected submit with 422 + the
// validation bag when the request asks for JSON, which is exactly the per-field detail the
// reference's own handler renders. Without JS the form posts normally and lands on
// /account/security, which shows the same result server-rendered.
{
    const form = document.querySelector("#r-side-bar #sidebar-chgPwdForm");

    if (form) {
        const success = form.querySelector(".message--chg-pass");
        const fields = ["currentPwd", "newPwd", "confirmPwd"];

        const errorSlot = (name) => {
            const input = form.querySelector(`[name="${name}"]`);
            if (!input) return null;
            const id = `${input.id}-error`;
            let slot = form.querySelector(`#${CSS.escape(id)}`);
            if (!slot) {
                slot = document.createElement("div");
                slot.id = id;
                slot.className = "text-danger";
                slot.setAttribute("role", "alert");
                input.insertAdjacentElement("afterend", slot);
            }
            return slot;
        };

        const clearErrors = () => {
            fields.forEach((name) => {
                const slot = errorSlot(name);
                if (slot) slot.textContent = "";
            });
        };

        form.addEventListener("submit", (event) => {
            event.preventDefault();
            clearErrors();
            if (success) success.style.display = "none";

            const submit = form.querySelector('button[type="submit"]');
            if (submit) submit.disabled = true;

            fetch(form.action, {
                method: "POST",
                body: new FormData(form),
                headers: {
                    Accept: "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
                credentials: "same-origin",
            })
                .then(async (response) => {
                    if (response.status === 422) {
                        const payload = await response.json();
                        Object.entries(payload.errors ?? {}).forEach(
                            ([name, messages]) => {
                                const slot = errorSlot(name);
                                if (slot) slot.textContent = messages[0];
                            },
                        );
                        form.querySelector(
                            `[name="${Object.keys(payload.errors ?? {})[0]}"]`,
                        )?.focus();

                        return;
                    }

                    if (!response.ok) {
                        showToast("Gagal mengubah kata sandi. Coba lagi.");

                        return;
                    }

                    form.reset();
                    if (success) success.style.display = "";
                })
                .catch(() => showToast("Gagal mengubah kata sandi. Coba lagi."))
                .finally(() => {
                    if (submit) submit.disabled = false;
                });
        });
    }
}

rememberRequestedDevice();
window.frontendPreview = {
    toast: showToast,
    openModal: openLogin,
    closeModal: closeLogin,
};
if (document.body.classList.contains("member-coverage")) {
    import("./member-coverage.js");
}
window.legacyReferenceReady = true;

// Copy buttons: [data-copy-target] names the field or element whose value/text is copied
// (the 2FA secret, the member's referral link).
document.addEventListener("click", (event) => {
    const trigger = event.target.closest?.("[data-copy-target]");
    if (!trigger) return;

    event.preventDefault();
    const source = document.querySelector(trigger.dataset.copyTarget);
    if (!source) return;

    const text = ("value" in source ? source.value : source.textContent).trim();
    if (text === "") return;

    const fallbackCopy = () => {
        const field = document.createElement("textarea");
        field.value = text;
        field.setAttribute("readonly", "");
        field.style.position = "fixed";
        field.style.opacity = "0";
        document.body.appendChild(field);
        field.select();
        const copied = document.execCommand("copy");
        field.remove();
        return copied;
    };

    const done = (copied) => showToast(copied ? "Berhasil disalin." : "Gagal menyalin, salin secara manual.");

    if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(text).then(() => done(true), () => done(fallbackCopy()));
    } else {
        done(fallbackCopy());
    }
});

// Header clock (desktop top bar): server-rendered in WIB, then kept ticking here.
document.querySelectorAll("[data-live-clock]").forEach((clock) => {
    const pad = (value) => String(value).padStart(2, "0");
    const render = () => {
        const parts = Object.fromEntries(
            new Intl.DateTimeFormat("en-GB", {
                timeZone: "Asia/Jakarta",
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
            })
                .formatToParts(new Date())
                .map((part) => [part.type, part.value]),
        );
        const hour24 = Number(parts.hour) % 24;
        const hour12 = hour24 % 12 || 12;
        clock.textContent = `${parts.day}/${parts.month}/${parts.year} ${hour12}:${pad(parts.minute)}:${pad(parts.second)} ${hour24 < 12 ? "am" : "pm"}`;
    };

    render();
    window.setInterval(render, 1000);
});

// Game artwork comes from each provider's own CDN, and a few of those files 404 upstream.
// Swap a failed thumbnail for the local placeholder instead of a broken-image icon. The
// listener runs in the capture phase because `error` does not bubble; images that already
// failed before this script ran are caught by the scan below.
{
    const GAME_IMAGE_FALLBACK = "/media/reference/provider-wall.png";
    const useFallback = (img) => {
        if (img.dataset.fallbackApplied || !img.closest(".game-box")) return;
        img.dataset.fallbackApplied = "1";
        img.src = GAME_IMAGE_FALLBACK;
        img.removeAttribute("data-src");
    };
    document.addEventListener(
        "error",
        (event) => {
            if (event.target instanceof HTMLImageElement) useFallback(event.target);
        },
        true,
    );
    document
        .querySelectorAll(".game-box img")
        .forEach((img) => {
            if (img.complete && img.naturalWidth === 0 && img.getAttribute("src")) useFallback(img);
        });
}
